import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";
import { FiDollarSign } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const PaymentProcessing = () => {
    const { t } = useTranslation();
    const description = t("service_pages.payment_processing.description");
    const features = t("service_pages.payment_processing.features", { returnObjects: true });
    const highlights = t("service_pages.payment_processing.highlights", { returnObjects: true });
    const steps = t("service_pages.payment_processing.steps", { returnObjects: true });
    const faqs = t("service_pages.payment_processing.faqs", { returnObjects: true });

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Payment Processing for Immigration Services",
        description,
        provider: {
            "@type": "LocalBusiness",
            name: "Citizen Hub Immigration Services",
            telephone: "+1 3108802133",
            email: "info@citznhub.com",
        },
        areaServed: ["United States", "California", "New York", "Texas", "Florida"],
    };

    // Create a simple icon-based image placeholder
    const IconPlaceholder = () => (
        <div className="w-full h-96 lg:h-[28rem] bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl shadow-lg flex items-center justify-center">
            <FiDollarSign className="w-48 h-48 text-white opacity-80" />
        </div>
    );

    return (
        <ServiceDetailLayout
            title={t("service_pages.payment_processing.title")}
            subtitle={t("service_pages.payment_processing.subtitle")}
            description={description}
            features={features}
            highlights={highlights}
            steps={steps}
            faqs={faqs}
            imageSrc={null}
            imageAlt="Secure payment processing"
            canonicalUrl="https://citizenhubimmigration.com/services/payment-processing"
            structuredData={structuredData}
            customImage={<IconPlaceholder />}
        />
    );
};

export default PaymentProcessing;
